module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.5@core-js/library/modules/_fails.js
// module id = 73
// module chunks = 16